import { useCallback } from "react";
import { useNavigate, generatePath } from "react-router-dom";
import { useSelectedOrganization } from "../organizations/hooks/useSelectedOrganization";
import { AbsoluteRoute } from "../../core/routes/absoluteRoutes";

export function useAppRoutes() {
    const navigate = useNavigate();
    const { selectedOrganizationId } = useSelectedOrganization();

    const navigateToOrganization = useCallback(() => {
        navigate(
            generatePath(AbsoluteRoute.ORG_LENS_SCHEDULER_GROUPS, {
                orgId: selectedOrganizationId ?? "",
            }),
        );
    }, [navigate, selectedOrganizationId]);

    const navigateToOrganizationApps = useCallback(
        (orgId?: string) => {
            navigate(generatePath(AbsoluteRoute.ORG_APPS, { orgId: orgId ?? selectedOrganizationId ?? "" }));
        },
        [navigate, selectedOrganizationId],
    );

    return { navigateToOrganization, navigateToOrganizationApps };
}
